<template>
  <div class="production-unit">
      <sui-segments>
          <sui-segment :loading="true" v-if="initialLoading"><br><br><br><br><br><br></sui-segment>
          <sui-segment class="production-unit-header" v-if="!initialLoading">
            <h1>{{ productionUnit.name }}</h1>
            <p>{{ productionUnit.description }}</p>
            <img src="@/assets/icons/transmitter.png" height="40" alt="">&nbsp;&nbsp;
            <img src="@/assets/icons/production-switcher.png" height="40" alt="">&nbsp;&nbsp;
            <img src="@/assets/icons/graphics.png" height="40" alt="">
            <br>
            <span>
            <i v-if="productionUnitState === 'offline'">Unit Offline, last start was on {{ productionUnit.start_timestamp | moment("dddd, MMMM Do YYYY [at] HH:mm A") }}</i>
            <i v-if="productionUnitState === 'online'">Unit Online <span v-if="uptimeStr">for {{ uptimeStr }}</span></i>
            <i v-if="productionUnitState === 'starting'">Unit Starting...  <span v-if="uptimeStr">Uptime: {{ uptimeStr }}</span></i>
            <i v-if="productionUnitState === 'stopping'">Unit Stopping</i>
            </span>
            <div class="start-stop">
                <sui-button primary v-if="productionUnitState === 'offline'" @click="startMachines">Start unit</sui-button>
                <sui-button primary v-else-if="productionUnitState === 'online'" @click="stopMachines">Stop unit</sui-button>
                <div class="loading" v-else>
                    <sui-loader :active="true"/>
                </div>
            </div>
          </sui-segment>
          <sui-segment v-if="!initialLoading">
                <h3>Machines</h3>
                <sui-list divided relaxed>
                    <sui-list-item v-for="machine in productionUnit.machines" :key="machine.id" class="item-padding">
                        <img class="icon" v-if="machine.type === 'production_switcher'" src="@/assets/icons/production-switcher.png" alt=""/>
                        <img class="icon" v-if="machine.type === 'graphics'" src="@/assets/icons/graphics.png" alt=""/>
                        <img class="icon" v-if="machine.type === 'transmitter'" src="@/assets/icons/transmitter.png" alt=""/>
                        <sui-list-content>
                            <span is="sui-list-header" class="machine-name">{{ machine.name }}</span>
                            <span is="sui-list-description">
                                <circle-state :service="machine.service" :state="machine.state"></circle-state>
                                <span style="text-transform: uppercase;">{{ machine.state }}</span>
                            </span>
                        </sui-list-content>
                        <div class="access">
                            <button class="ui primary button" v-if="machine.service === 'WS'" @click="access(machine)" :disabled="machine.state !== 'available'">Access</button>
                            <button class="ui primary button" v-if="machine.service === 'EC2'" @click="access(machine)" :disabled="machine.state !== 'running'">Access</button>
                        </div>
                    </sui-list-item>
                </sui-list>
          </sui-segment>
      </sui-segments>
          <!-- Start error modal -->
    <modal v-if="startingMachinesModal" :title="'Error: Starting machines'" :ok="'Ok'" @ok="startingMachinesModal = false">
      <p>We encountered a problem during machines startup. Some might have been able to start.</p>
      <small><b>ERROR DETAIL</b></small>
      <pre>
{{ startingMachinesError }}        
      </pre>
    </modal>

    <!-- Stop error modal -->
    <modal v-if="stoppingMachinesModal" :title="'Error: Stopping machines'" :ok="'Ok'" @ok="stoppingMachinesModal = false">
      <p>We encountered a problem during machines shutdown. Some might have been able to stop.</p>
      <small><b>ERROR DETAIL</b></small>
      <pre>
{{ stoppingMachinesError }}        
      </pre>
    </modal>

    <!-- Access modal -->
    <modal v-if="accessModal" :title="accessModalTitle" :cancel="'Dismiss'" @cancel='accessModal = false'>
      <div>
        <!-- <p>You have to install Microsoft's remote desktop client software.
          <br>It's built-in in Windows with the "Remote Desktop Connection" app.
          On a Mac you'd have to install it from <a href="https://apps.apple.com/us/app/microsoft-remote-desktop-10/id1295203466?mt=12" target="_blank">there</a>.
        </p> -->
        <div>
          <h3>Access Credentials</h3>
          <sui-table padded>
            <thead>
              <tr v-if="accessModalMachine.service === 'EC2'">
                <td>Host</td>
                <td class="copiable" @click="copyPassword(accessModalMachine.publicIp)">{{ accessModalMachine.publicIp }}</td>
              </tr>
              <tr v-else>
                <td>Registration code</td>
                <td class="copiable" @click="copyPassword(accessModalMachine.registrationCode)">{{ accessModalMachine.registrationCode }}</td>
              </tr>
              <tr>
                <td>User</td>
                <td class="copiable" @click="copyPassword(accessModalMachine.user)">{{ accessModalMachine.user }}</td>
              </tr>
              <tr>
                <td>Password</td>
                <td class="copiable" @click="copyPassword(accessModalMachine.password)">{{ accessModalMachine.password }}</td>
              </tr>
            </thead>
          </sui-table>
        </div>
        <br>
        <div class="grid has-gutter" v-if="accessModalMachine.service === 'EC2'">
          <div>
            <h3>macOS</h3>
            <a :href="`rdp://full%20address=s:${accessModalMachine.publicIp}:3389&username=s:${accessModalMachine.user}`"><sui-button primary>Open Microsoft Remote Desktop</sui-button></a>
            <br><br>
            <small>The Microsoft RDP software for Mac is available <a href="https://apps.apple.com/us/app/microsoft-remote-desktop-10/id1295203466?mt=12" target="_blank">here</a></small>
          </div>
        </div>
        <div class="grid has-gutter" v-if="accessModalMachine.service === 'EC2'">
          <br>
          <div>
            <h3>NiceDCV</h3>
            <a :href="`https://${accessModalMachine.publicIp}:8443`" target="_blank"><sui-button primary>Open NiceDCV</sui-button></a>
            <br><br>
            <small>NiceDCV is only supported on a selection of machines.</small>
          </div>
        </div>
        <div v-else>
          <h3>Connect</h3>
          <a :href="`workspaces://${encodeURIComponent(accessModalMachine.user)}@${accessModalMachine.registrationCode}`"><button>Connect to the machine</button></a>
          <br><br>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import productionUnitsService from './../services/production-units';
import Modal from '../components/Modal'
import CircleState from '../components/CircleState'

export default {
  name: "productionUnit",
  components: { CircleState, Modal },
  data () {
    return {
        productionUnit: null,
        loading: true,
        productionUnitState: 'offline',
        startingMachinesModal: false,
        startingMachinesError: '',
        stoppingMachinesModal: false,
        stoppingMachinesError: '',
        accessModal: false,
        accessModalMachine: null,
        accessModalTitle: '',
        intervalRefresh: null,
        intervalUptime: null,
        uptimeStr: null,
        initialLoading: true
    }
  },
  mounted () {
    this.fetch();
    this.intervalRefresh = setInterval(() => this.fetch(), 5000);
    this.intervalUptime = setInterval(() => this.updateUptime(),1000)
  },
  methods: {
    fetch() {
        if (!this.$route.params.id) {
            clearInterval(this.intervalRefresh);
            return;
        }
        productionUnitsService.getProductionUnit(this.$route.params.id).then(productionUnit => {
            this.productionUnit = productionUnit;
            let startingMachines = 0;
            let stoppingMachines = 0;
            let stoppedMachines = 0;
            let erroredMachines = 0;
            let runningMachines = 0;

            for (let machine of this.productionUnit.machines) {
                if (machine.state === 'starting')        startingMachines++;
                else if (machine.state === 'pending')    startingMachines++;
                else if (machine.state === 'stopping')   stoppingMachines++;
                else if (machine.state === 'stopped')    stoppedMachines++;
                else if (machine.state === 'available')  runningMachines++;
                else if (machine.state === 'running')    runningMachines++;
                else                                     erroredMachines++;
            }

            if (startingMachines >= 1)
            this.productionUnitState = 'starting';
            if (stoppingMachines >= 1)
            this.productionUnitState = 'stopping';
            if (stoppedMachines === this.productionUnit.machines.length)
            this.productionUnitState = 'offline';
            if (runningMachines === this.productionUnit.machines.length)
            this.productionUnitState = 'online';
            if (erroredMachines >= 1)
            this.productionUnitState = 'offline';

            this.updateUptime()

            this.loading = false;
            if (this.initialLoading) {
                this.initialLoading = false;
            }
        });
    },
    startMachines() {
      this.productionUnitState = 'starting';
      this.uptimeStr = '';
      productionUnitsService.startProductionUnit(this.$route.params.id).then(start => {
        console.log(start)
      }).catch(error => {
        this.startingMachinesModal = true;
        this.startingMachinesError = error;
      });
    },
    stopMachines() {
      this.productionUnitState = 'stopping';
      productionUnitsService.stopProductionUnit(this.$route.params.id).then(start => {
        console.log(start)
      }).catch(error => {
        this.stoppingMachinesModal = true;
        this.stoppingMachinesError = error;
      });
    },
    access (machine) {
      if (machine.service === 'EC2') this.accessModalTitle = `Microsoft RDP access instructions for ${machine.name}`;
      if (machine.service === 'WS') this.accessModalTitle = `PCoIP Workspace access instructions for ${machine.name}`;
      this.accessModalMachine = machine;
      this.accessModal = true;
    },
    copyPassword (password) {
      this.$copyText(password);
    },
    updateUptime() {
      if (this.productionUnit && this.productionUnitState === 'online') {
        let currentStamp = Date.now();
        let uptime = currentStamp - this.productionUnit.start_timestamp;
        this.uptimeStr = new Date(uptime).toISOString().substr(11, 8);
      }
    }
  },
  beforeDestroy() {
      clearInterval(this.intervalRefresh);
      clearInterval(this.intervalUptime);
  }
};
</script>

<style lang="scss" scoped>
.production-unit {
    .production-unit-header{
         background: url('../assets/control_room.jpg') !important;
         color: white !important;
         background-size: cover;
         border-radius: 4px 4px 0 0;
         padding: 15px 15px 15px 15px !important;
   
         img {
           opacity: 0.25;
           display: inline-block;
         }
   
         .start-stop {
           position: absolute;
           right: 15px;
           bottom: 15px;
           .loading {
               margin: 20px;
               margin-bottom: 25px;
           }
         }
       }

        .access {
            position: absolute;
            top: 12px;
            right: 10px;
        }

        .machine-name {
            margin-bottom: 8px !important;
            font-size: 16px;
        }

        .item-padding {
            padding: 10px !important;
            position: relative;
        }

       img.icon {
           height: 36px;
           float: left;
           margin-right: 10px;
            filter: brightness(50%);
       }

       .copiable {
           font-size: 15px;
           text-decoration: underline;
           text-decoration-color: rgb(184, 184, 184);
           cursor: pointer;
           &:hover {
                text-decoration-color: black;
           }
       }
}
</style>